<template>
	<li class='deals__item c-deal-item c-deal-item-list'
		:data-item-id='deal.id'
		v-bind:class='{ border: isActive }'
	>
		<a class='image-wrapper' :href='`/deals/${deal.id}/edit`'>
			<div class='image'>
				<!-- <img src='/assets/img/hightQualityPhotoTest.png'> -->
				<!-- <img :src='deal.image'> -->
				<c-img class='cover' :src='(deal.image)?(deal.image):("/assets/img/placeholder.png")' :ratio='340/255' />
			</div>
		</a>
		<div class='description'>
			<a class='title' :href='`/deals/${deal.id}/edit`'>
				{{deal.address}}
			</a>
			<dealCounts :deal='deal' />
			<Items2 v-if='page === "EditDeal" || page==="Maintenance" || page==="Tenants"' :deal='deal' />
			<Items v-else :deal='deal' />
			<div class='price' >
				<h2>
					Price: $ {{deal.home_price | formatPrice}}
				</h2>
			</div>
		</div>
		<a class='btn btn--white waves-effect dela__edit' :href='`/deals/${deal.id}/edit`' v-if='canEditBtn'>
			<svg class='icon'>
				<use xlink:href='#icon-edit'/>
			</svg>
		</a>
		<a class='btn btn--white waves-effect dela__new' :href='`/deals/new?copy_from=${deal.id}`' v-if='canDeleteBtn'>
			<svg class='icon'>
				<use xlink:href='#icon-clone' />
			</svg>
		</a>

	</li>
</template>

<script>
import deal from '../mixins/deal';
import Items from './components/Items/Items.vue';
import Items2 from './components/Items2/Items2.vue';
import EventBus from '__jsEbentBus';
export default {
	name:       'DealList',
	mixins:     [deal],
	components: {
		Items,
		Items2,
	},
	data: function() {
		return {
			isActive: false,
			hasError: false
		};
	},
	mounted() {
		setTimeout(() => {
			EventBus.$emit('initToTop');
		}, 0);
	}
};
</script>
